"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
BearingFilter.$inject = [];
function BearingFilter() {
    return function (bearing) {
        var b = parseFloat(bearing);
        return b < 0 ? (b + 360) : b;
    };
}
exports.BearingFilter = BearingFilter;
;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/filters/BearingFilter.js
// module id = 600
// module chunks = 0